"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentTypeFromOutlineOrSummary = exports.UpvoteAction = exports.ContentTypeToPrettyContentType = exports.ContentType = exports.COMMENT_ANCHOR_LINK = void 0;
const index_1 = __importDefault(require("assert-never/index"));
exports.COMMENT_ANCHOR_LINK = 'comments';
var ContentType;
(function (ContentType) {
    ContentType["NOTECARD"] = "NOTECARD";
    ContentType["PRACTICE_PROBLEM"] = "PRACTICE_PROBLEM";
    ContentType["OUTLINE"] = "OUTLINE";
    ContentType["SUMMARY"] = "SUMMARY";
})(ContentType || (exports.ContentType = ContentType = {}));
exports.ContentTypeToPrettyContentType = {
    [ContentType.NOTECARD]: 'notecard',
    [ContentType.PRACTICE_PROBLEM]: 'practice problem',
    [ContentType.OUTLINE]: 'outline',
    [ContentType.SUMMARY]: 'outline summary',
};
var UpvoteAction;
(function (UpvoteAction) {
    UpvoteAction["ADD"] = "ADD";
    UpvoteAction["REMOVE"] = "REMOVE";
})(UpvoteAction || (exports.UpvoteAction = UpvoteAction = {}));
const getContentTypeFromOutlineOrSummary = (outlineOrSummary) => {
    switch (outlineOrSummary) {
        case 'outline':
            return ContentType.OUTLINE;
        case 'summary':
            return ContentType.SUMMARY;
        default:
            (0, index_1.default)(outlineOrSummary);
    }
};
exports.getContentTypeFromOutlineOrSummary = getContentTypeFromOutlineOrSummary;
//# sourceMappingURL=types.js.map